<template>
  <Loading :loading="loading">
    <template>
      <b-row class="margin-0 section">
        <b-col
          cols="12"
          class="padding-0 flex-center flex-direction-column margin-bottom-16"
        >
          <b-img-lazy
            :src="generateImage"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-20')`"
            width="132"
            class="border-radius-40 background-double-light-gray margin-bottom-16"
          />
          <span
            class="font-size-20 line-height-35 color-complementary-300 margin-bottom-8"
          >
            {{ `${headProfileGenerated.name} ${headProfileGenerated.family}` }}
          </span>
          <span class="font-size-16 line-height-28 color-complementary-300">
            {{ headProfileGenerated.nationalCode }}
          </span>
        </b-col>
        <BoxList
          v-if="checkEmptyObject(profileGenerated)"
          :label="$lang.profile_view"
          :items="profileGenerated"
        />
        <BoxList
          v-if="checkEmptyObject(completeHistory)"
          :label="$lang.complete_history"
          :items="completeHistory"
        />
        <BoxList
          v-if="checkEmptyObject(contactGenerated)"
          :label="$lang.contactPerson"
          :items="contactGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(wifeGenerated)"
          :label="$lang.wife_info"
          :items="wifeGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(addressGenerated)"
          :label="$lang.addressPerson"
          :items="addressGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(jobsGenerated)"
          :label="$lang.jobExperienceTitle"
          :items="jobsGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(educationsGenerated)"
          :label="$lang.educationExperience"
          :items="educationsGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(socialsGenerated)"
          :label="$lang.cultural_social"
          :items="socialsGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(licensesGenerated)"
          :label="$lang.licenses_label"
          :items="licensesGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(freeCoursesGenerated)"
          :label="$lang.Free_courses_education"
          :items="freeCoursesGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(articlesGenerated)"
          :label="$lang.article"
          :items="articlesGenerated"
        />
        <BoxListChildren
          v-if="checkEmptyObject(familyRelationsGenerated)"
          :label="$lang.family_relations"
          :items="familyRelationsGenerated"
        />
        <b-col
          v-if="skillsGenerated"
          cols="12"
          class="padding-0 margin-bottom-16"
        >
          <div class="font-size-14 color-complementary-400 margin-bottom-8">
            {{ $lang.skills }}
          </div>
          <div
            class="font-size-12 color-complementary-300 margin-bottom-8 padding-right-10"
          >
            {{ skillsGenerated }}
          </div>
        </b-col>
      </b-row>
    </template>
  </Loading>
</template>

<script>
import Loading from "./Loading.vue";
import BoxList from "./BoxList.vue";
import BoxListChildren from "./BoxListChildren.vue";
import { pathOr } from "ramda";
import { getPersonInformation } from "@/services";

export default {
  components: { Loading, BoxList, BoxListChildren },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      defaultImage: this.$config.images.shared.redesign.empty.noUser,
      profile: null,
      contact: null,
      wife: [],
      address: [],
      jobs: [],
      educations: [],
      socials: [],
      licenses: [],
      skills: [],
      freeCourses: [],
      articles: [],
      familyRelations: [],
    };
  },
  computed: {
    generateImage() {
      const imageData = pathOr([], ["attachments"], this.profile);
      const address = pathOr(
        "",
        ["address"],
        imageData.find((row) => row.type === "thumb")
      );
      return address;
    },
    headProfileGenerated() {
      return {
        name: pathOr("", ["name"], this.profile),
        family: pathOr("", ["family"], this.profile),
        nationalCode: pathOr("", ["national_code"], this.profile),
      };
    },
    profileGenerated() {
      const isMan = pathOr(1, ["gender_id"], this.profile) === 1;
      const data = [
        {
          label: this.$lang.previous_family,
          value: pathOr("", ["previous_family"], this.profile),
        },
        {
          label: this.$lang.father_name,
          value: pathOr("", ["father_name"], this.profile),
        },
        {
          label: this.$lang.birth_date,
          value: pathOr("", ["birth_date"], this.profile),
        },
        {
          label: this.$lang.birth_location,
          value: pathOr("", ["birth_location"], this.profile),
        },
        {
          label: this.$lang.Place_identity_card,
          value: pathOr("", ["place_issue"], this.profile),
        },
        {
          label: this.$lang.identify_number,
          value: pathOr("", ["identify"], this.profile),
        },
        {
          label: this.$lang.nickname,
          value: pathOr("", ["nickname"], this.profile),
        },
        {
          label: this.$lang.allegiance,
          value: pathOr("", ["allegiance"], this.profile),
        },
        {
          label: this.$lang.gender,
          value: pathOr("", ["gender"], this.profile),
        },
        {
          label: this.$lang.marriage,
          value: pathOr("", ["marriage"], this.profile),
        },
        {
          label: this.$lang.military,
          value: isMan ? pathOr("", ["military"], this.profile) : null,
        },
        {
          label: this.$lang.mobile,
          value: pathOr("", ["mobile"], this.profile),
        },
      ];
      return data.filter((item) => item.value);
    },
    completeHistory() {
      const data = [
        {
          label: this.$lang.biography_label,
          value: pathOr("", ["biography"], this.profile),
        },
        {
          label: this.$lang.favoritesAndActivity,
          value: pathOr("", ["favorites"], this.profile),
        },
        {
          label: this.$lang.final_introduction_label,
          value: pathOr("", ["final_introduction"], this.profile),
        },
        {
          label: this.$lang.conviction_history_label,
          value: pathOr("", ["conviction_history"], this.profile),
        },
      ];
      return data.filter((item) => item.value);
    },
    contactGenerated() {
      const data = [
        {
          label: this.$lang.mobileNumber,
          value: pathOr([], ["mobile"], this.contact).join(" - "),
        },
        {
          label: this.$lang.email,
          value: pathOr("", ["email"], this.contact),
        },
        {
          label: this.$lang.home_phone,
          value: pathOr("", ["home_phone"], this.contact),
        },
        {
          label: this.$lang.workplace_number,
          value: pathOr("", ["work_phone"], this.contact),
        },
        {
          label: this.$lang.social_messenger,
          value: pathOr("", ["messenger"], this.contact),
        },
        {
          label: this.$lang.website,
          value: pathOr("", ["site"], this.contact),
        },
      ];
      return data.filter((item) => item.value);
    },
    wifeGenerated() {
      const data = this.wife.map((item) => {
        const name = pathOr("", ["name"], item);
        const family = pathOr("", ["family"], item);
        const children = [
          { label: this.$lang.mobile, value: pathOr("", ["mobile"], item) },
          {
            label: this.$lang.zone_number,
            value: pathOr("", ["zone_number"], item),
          },
          {
            label: this.$lang.national_code,
            value: pathOr("", ["national_code"], item),
          },
          {
            label: this.$lang.birth_date,
            value: pathOr("", ["birth_date"], item),
          },
          {
            label: this.$lang.date_marriage,
            value: pathOr("", ["marriage_date"], item),
          },
          {
            label: this.$lang.date_separation_death,
            value: pathOr("", ["separation_date"], item),
          },
          {
            label: this.$lang.date_death,
            value: pathOr("", ["death_date"], item),
          },
          {
            label: this.$lang.description,
            value: pathOr("", ["description"], item),
          },
        ];
        return {
          label: this.$lang.full_name,
          value: `${name} ${family}`,
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    addressGenerated() {
      const data = this.address.map((item) => {
        const children = [
          {
            label: this.$lang.full_path,
            value: pathOr("", ["full_path"], item),
          },
          {
            label: this.$lang.zone_number,
            value: pathOr("", ["zone_number"], item),
          },
          {
            label: this.$lang.address,
            value: pathOr("", ["address"], item),
          },
          {
            label: this.$lang.postal_code,
            value: pathOr("", ["postal_code"], item),
          },
          {
            label: this.$lang.from_year,
            value: pathOr("", ["from_year"], item),
          },
          {
            label: this.$lang.to_year,
            value: pathOr("", ["to_year"], item),
          },
        ];
        return {
          label: this.$lang.kind_address,
          value: pathOr("", ["kind"], item),
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    jobsGenerated() {
      const data = this.jobs.map((item) => {
        const fromYearMonth = pathOr("", ["from_year_month"], item);
        const toYearMonth = pathOr("", ["to_year_month"], item);
        const children = [
          {
            label: this.$lang.place_name_label,
            value: pathOr("", ["name"], item),
          },
          {
            label: this.$lang.organization_type,
            value: pathOr("", ["organization_type", "caption"], item),
          },
          {
            label: this.$lang.job_level,
            value: pathOr("", ["job_level", "caption"], item),
          },
          {
            label: this.$lang.job_position,
            value: pathOr("", ["position"], item),
          },
          {
            label: this.$lang.address,
            value: pathOr("", ["address", "full_path"], item),
          },
        ];
        const relation = pathOr([], ["relation"], item);
        const relations = relation.map((relItem) => {
          const name = pathOr("", ["name"], relItem);
          const family = pathOr("", ["family"], relItem);
          return {
            children: [
              {
                label: this.$lang.full_name,
                value: `${name} ${family}`,
              },
              {
                label: this.$lang.mobile,
                value: pathOr("", ["mobile"], relItem),
              },
              {
                label: this.$lang.address,
                value: pathOr("", ["address"], relItem),
              },
            ],
          };
        });
        return {
          label: this.$lang.from,
          value: `${fromYearMonth} - ${toYearMonth}`,
          children: children.filter((child) => child.value),
          relations,
        };
      });
      return data.filter((item) => item.value);
    },
    educationsGenerated() {
      const data = this.educations.map((item) => {
        const children = [
          {
            label: this.$lang.education_grade,
            value: pathOr("", ["education_grade", "caption"], item),
          },
          {
            label: this.$lang.education_place,
            value: pathOr("", ["education_place"], item),
          },
          {
            label: this.$lang.full_path,
            value: pathOr("", ["full_path"], item),
          },
          {
            label: this.$lang.from_year,
            value: pathOr("", ["from_year"], item),
          },
          {
            label: this.$lang.to_year,
            value: pathOr("", ["to_year"], item),
          },
        ];
        const relation = pathOr([], ["relation"], item);
        const relations = relation.map((relItem) => {
          const name = pathOr("", ["name"], relItem);
          const family = pathOr("", ["family"], relItem);
          return {
            children: [
              {
                label: this.$lang.full_name,
                value: `${name} ${family}`,
              },
              {
                label: this.$lang.mobile,
                value: pathOr("", ["mobile"], relItem),
              },
              {
                label: this.$lang.address,
                value: pathOr("", ["address"], relItem),
              },
            ],
          };
        });

        return {
          label: this.$lang.education_field,
          value: pathOr("", ["education_field"], item),
          children: children.filter((child) => child.value),
          relations,
        };
      });
      return data.filter((item) => item.value);
    },
    socialsGenerated() {
      const data = this.socials.map((item) => {
        const children = [
          {
            label: this.$lang.full_path,
            value: pathOr("", ["address", "location", "full_path"], item),
          },
          {
            label: this.$lang.from_year,
            value: pathOr("", ["from_year"], item),
          },
          {
            label: this.$lang.to_year,
            value: pathOr("", ["to_year"], item),
          },
          {
            label: this.$lang.description,
            value: pathOr("", ["description"], item),
          },
        ];
        const relation = pathOr([], ["relation"], item);
        const relations = relation.map((relItem) => {
          const name = pathOr("", ["name"], relItem);
          const family = pathOr("", ["family"], relItem);
          return {
            children: [
              {
                label: this.$lang.full_name,
                value: `${name} ${family}`,
              },
              {
                label: this.$lang.mobile,
                value: pathOr("", ["mobile"], relItem),
              },
              {
                label: this.$lang.address,
                value: pathOr("", ["address"], relItem),
              },
            ],
          };
        });

        return {
          label: this.$lang.company_name_label,
          value: pathOr("", ["name"], item),
          children: children.filter((child) => child.value),
          relations,
        };
      });
      return data.filter((item) => item.value);
    },
    licensesGenerated() {
      const data = this.licenses.map((item) => {
        const children = [
          {
            label: this.$lang.license_place_name,
            value: pathOr("", ["license_place_name"], item),
          },
          {
            label: this.$lang.license_full_path,
            value: pathOr("", ["location", "full_path"], item),
          },
          {
            label: this.$lang.license_number,
            value: pathOr("", ["license_no"], item),
          },
          {
            label: this.$lang.license_year,
            value: pathOr("", ["license_year"], item),
          },
        ];
        return {
          label: this.$lang.license_title,
          value: pathOr("", ["name"], item),
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    freeCoursesGenerated() {
      const data = this.freeCourses.map((item) => {
        const children = [
          {
            label: this.$lang.free_courses_education_place,
            value: pathOr("", ["education_place"], item),
          },
          {
            label: this.$lang.free_courses_full_path,
            value: pathOr("", ["location", "full_path"], item),
          },
          {
            label: this.$lang.from_year,
            value: pathOr("", ["from_year"], item),
          },
          {
            label: this.$lang.to_year,
            value: pathOr("", ["to_year"], item),
          },
        ];
        return {
          label: this.$lang.free_courses_title,
          value: pathOr("", ["title"], item),
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    articlesGenerated() {
      const data = this.articles.map((item) => {
        const children = [
          {
            label: this.$lang.articles_full_path,
            value: pathOr("", ["location", "full_path"], item),
          },
          {
            label: this.$lang.Year_publication,
            value: pathOr("", ["year"], item),
          },
          {
            label: this.$lang.description,
            value: pathOr("", ["description"], item),
          },
        ];
        return {
          label: this.$lang.book_title,
          value: pathOr("", ["name"], item),
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    familyRelationsGenerated() {
      const data = this.familyRelations.map((item) => {
        const children = [
          {
            label: this.$lang.family_relation_type,
            value: pathOr("", ["relation_type", "caption"], item),
          },
          {
            label: this.$lang.birth_date,
            value: pathOr("", ["birth_date"], item),
          },
          {
            label: this.$lang.national_code,
            value: pathOr("", ["national_code"], item),
          },
          {
            label: this.$lang.mobile,
            value: pathOr("", ["mobile"], item),
          },
          {
            label: this.$lang.full_path,
            value: pathOr("", ["location", "full_path"], item),
          },
          {
            label: this.$lang.zone_number,
            value: pathOr("", ["zone_number"], item),
          },
          {
            label: this.$lang.description,
            value: pathOr("", ["description"], item),
          },
        ];

        const name = pathOr("", ["name"], item);
        const family = pathOr("", ["family"], item);
        return {
          label: this.$lang.full_name,
          value: `${name} ${family}`,
          children: children.filter((child) => child.value),
        };
      });
      return data.filter((item) => item.value);
    },
    skillsGenerated() {
      return this.skills.length
        ? this.skills
            .map((item) => pathOr("", ["skill_caption"], item))
            .join("، ")
        : null;
    },
  },
  watch: {
    code: {
      immediate: true,
      handler(value) {
        value && this.fetchData();
      },
    },
    loading: {
      immediate: true,
      handler(value) {
        this.$emit("trackLoading", value);
      },
    },
  },
  methods: {
    pathOr,
    async fetchData() {
      try {
        this.loading = true;
        const response = await getPersonInformation(this.code);
        const {
          profile,
          contact,
          wife,
          address,
          jobs,
          educations,
          socials,
          licenses,
          skill: skills,
          free_courses: freeCourses,
          articles,
          family_relations: familyRelations,
        } = response;

        this.profile = profile;
        this.contact = contact;
        this.wife = wife;
        this.address = address;
        this.jobs = jobs;
        this.educations = educations;
        this.socials = socials;
        this.licenses = licenses;
        this.skills = skills;
        this.freeCourses = freeCourses;
        this.articles = articles;
        this.familyRelations = familyRelations;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    checkEmptyObject(data) {
      if (Array.isArray(data)) {
        return !!data.length;
      } else {
        return Object.keys(data).some((key) => data[key]);
      }
    },
  },
};
</script>
